<footer class="inm-layout-footer">{{copyright}}</footer>